import { render, staticRenderFns } from "./MSecondaryPlanChange.vue?vue&type=template&id=5a5c45b6&"
import script from "./MSecondaryPlanChange.vue?vue&type=script&lang=ts&"
export * from "./MSecondaryPlanChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports